import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/admin-pages/admin.service';

@Component({
  selector: 'app-pay-in',
  templateUrl: './pay-in.component.html',
  styleUrls: ['./pay-in.component.scss']
})
export class PayInComponent implements OnInit {
  @Input() defaultCustomer: any = null;
  @Input() isCustomerDisabled: boolean = false;
  @Output() transactionSaved = new EventEmitter<any>();
  @Output() close = new EventEmitter<void>();
  @Input() JobOrderId: any;

  payInForm!: FormGroup;
  usersList: any[] = [];
  showPaymentModesModal: boolean = false;
  calledFrom: string = 'pay-in';
  paymentInfo:any;
  // isSubmitEnabled: boolean = false;
  
  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
  ) { }

  ngOnInit(): void {
    this.getUserList();
    this.setAllForms();

    if (this.isCustomerDisabled) {
      this.payInForm.get('customer')?.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['defaultCustomer'] && this.payInForm) {
      this.payInForm.get('customer')?.setValue(this.defaultCustomer);
    }
  }

  onClose() {
    this.close.emit();
    this.payInForm.reset({
      customer: this.defaultCustomer
    });
  }

  onSubmit(): void {
    if (this.payInForm.valid) {
      const FirstName = this.customer?.value.FirstName || '';
      const LastName = this.customer?.value.LastName || '';
      let params: any = {
        customerName: FirstName + " " + LastName,
        customerID: this.customer?.value.ID,
      }
      params['orderId'] = this.JobOrderId || 0;
      params['totalAmount'] = this.paymentInfo.totalReceivedAmount;
      params['paymentModes'] = this.paymentInfo.paymentModesString || '';

      this.adminService.saveTransactionByConfiguration(params).subscribe((res: any) => {

        if (res?.Result == "Success") {
          // this.configService.notify({
          //   severity: 'success',
          //   summary: 'Success',
          //   detail: `Transaction saved successfully.`,
          // });

          this.transactionSaved.emit(res);
          this.payInForm.reset({
            customer: this.defaultCustomer
          });
          this.onClose();
        }

      }, (err: HttpErrorResponse) => {
        // this.configService.notify({
        //   severity: 'error',
        //   summary: 'Failed',
        //   detail: `Failed to save transaction.`,
        // });
      });

    } else {
      this.payInForm.markAllAsTouched();
      // this.configService.notify({
      //   severity: 'error',
      //   summary: 'Failed',
      //   detail: `Enter all required fields.`,
      // });
    }
  }

  get customer() {
    return this.payInForm.get('customer');
  }

  get amount() {
    return this.payInForm.get('amount');
  }

  get method() {
    return this.payInForm.get('method');
  }

  get bank() {
    return this.payInForm.get('bank');
  }

  private setAllForms() {
    this.payInForm = this.fb.group({
      customer: [this.defaultCustomer ? this.defaultCustomer : null, Validators.required],
      amount: ['', [Validators.required, Validators.min(0.01)]],
      // method: [null, Validators.required],
      bank: [null]
    });
  }

  private getUserList() {
    let params = {
      takeAll: false,
      skip: 0,
      take: 100,
      keyWord: '',
      isDateChecked: false,
      fromDate: null,
      toDate: null,
      userType: 'user,shop',
    };
    this.adminService.getUsersAndShopsForAdmin(params).subscribe((res: any) => {
      if (res?.Result == "Success" && res?.ResponseData) {
        this.usersList = res.ResponseData;
      }
    }, (err: HttpErrorResponse) => {

    });
  }

  public compareById = (o1: any, o2: any) => o1 && o2 && o1.ID === o2.ID;

  public handlePaymentModalClose() {
    this.showPaymentModesModal = false;
  }

  public handlePaymentSaved(event: { paymentModes: any[]; totalAmount: number; changeToReturn: number; calledFrom: string }) {
    const paymentModesString = JSON.stringify(event.paymentModes);
    const change = event.changeToReturn;
    const totalReceivedAmount = event.totalAmount;
    this.paymentInfo = {
      change,
      paymentModesString,
      totalReceivedAmount,
    }
    // this.isSubmitEnabled=true;
    this.onSubmit();
  }

  public openPaymentModal() {
    this.showPaymentModesModal = true;
  }

}
